import type { ScreenContext } from './types.ts';
import { createContinueButton } from '@/components/continue-button.ts';

export function renderOnboarding(container: HTMLElement, { dispatch }: ScreenContext) {
  container.innerHTML = `
    <div class="card space-y-6">
      <div class="space-y-2 text-center">
        <div class="text-4xl">🎵</div>
        <h2 class="text-2xl font-semibold text-gray-900">The emotional echo of music</h2>
        <p class="text-gray-700">A 6–7 minute guided session exploring how music shapes your mood.</p>
      </div>
      <div class="space-y-2 text-sm text-gray-800">
        <div class="bg-blue-50 border border-blue-100 rounded-lg p-4 text-blue-900">
          <p>This experience is for self-reflection only. It is not clinical advice or therapy.</p>
        </div>
        <div class="bg-gray-50 border border-gray-200 rounded-lg p-4">
          <p class="font-medium text-gray-900">For best results:</p>
          <ul class="list-disc pl-5 space-y-1 text-gray-700">
            <li>Use headphones in a quiet space.</li>
            <li>Set your volume to a comfortable level.</li>
            <li>Run the quick audio test below.</li>
          </ul>
          <button id="audio-test" class="btn-secondary w-full mt-3">Play test tone</button>
          <p id="audio-test-status" class="text-xs text-gray-600 mt-1"></p>
        </div>
      </div>
      <label class="flex items-start gap-3 text-sm text-gray-800">
        <input type="checkbox" id="consent" class="mt-1">
        <span>I understand this is an exploratory tool and not a medical product.</span>
      </label>
      <div id="action-slot"></div>
    </div>
  `;

  const actionSlot = container.querySelector('#action-slot') as HTMLElement;
  const btn = createContinueButton('Start Session', { disabled: true });
  actionSlot.appendChild(btn);

  const status = container.querySelector('#audio-test-status') as HTMLElement | null;
  const testBtn = container.querySelector('#audio-test') as HTMLButtonElement | null;

  const playTestTone = async () => {
    try {
      const ctx = new AudioContext();
      const osc = ctx.createOscillator();
      osc.type = 'sine';
      osc.frequency.value = 440;
      osc.connect(ctx.destination);
      osc.start();
      osc.stop(ctx.currentTime + 1.2);
      status && (status.textContent = 'Test tone played. Adjust your volume if needed.');
    } catch (err) {
      status && (status.textContent = 'Could not play the test tone in this browser.');
      console.error('Audio test failed', err);
    }
  };

  testBtn?.addEventListener('click', playTestTone);

  const consent = container.querySelector<HTMLInputElement>('#consent');
  consent?.addEventListener('change', () => {
    btn.disabled = !consent.checked;
  });

  btn.addEventListener('click', () => {
    dispatch({ type: 'NEXT_PHASE' });
  });
}
